module.exports = __webpack_public_path__ + "static/media/verifi_acct_nbbzpr.f15ce993.jpg";